import { render } from "./NewsletterSubscriptions.vue?vue&type=template&id=4d5ece04&scoped=true"
import script from "./NewsletterSubscriptions.vue?vue&type=script&lang=js"
export * from "./NewsletterSubscriptions.vue?vue&type=script&lang=js"

import "./NewsletterSubscriptions.vue?vue&type=style&index=0&id=4d5ece04&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5ece04"]])

export default __exports__